import {eventSlots} from "../../utils/eventSetup";

export const hasMatchFormat = tag => ["scrim", "game day", "premier", "other"].includes(String(tag || "").trim().toLowerCase());

export function withSetupTag(value, tag) {
  value={...value,scrimType:tag === 'Scrim' ? value.scrimType || '' : ''};
  if (hasMatchFormat(tag)) return {...value, tag};
  const slots = eventSlots(value);
  if (slots.slice(1).some(slot => slot.matchId || slot.statsId || slot.localMatchId)) {
    throw new Error("This event has linked recordings or Team Stats on additional maps. Keep a match-format tag to preserve those links.");
  }
  return {...value, tag, matchFormat: "", opponentName: "", mapSlots: slots.slice(0, 1)};
}
